import React from 'lib/react';
import {
  EVButton,
  EVPaper, EVTypography, makeStyles,
  EVRefreshOutlinedIcon,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useDispatch } from 'lib/redux';
import useMediaQuery from 'hooks/useMediaQuery';
import { loadOrderHistoryPage } from '../OrderHistory.actions';

const useStyles = makeStyles((theme) => ({
  retryScreenPaper: {
    margin: 0,
    padding: '24px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '20px',
    '@media (min-width: 640px)': {
      padding: '84px',
      backgroundColor: theme.evPalette.salt[100],
      margin: '16px 24px',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  },
  retryBtn: {
    height: '36px',
    backgroundColor: theme.evPalette.ocean[600],
    padding: '10px',
    radius: '4px',
    gap: '8px',
  },
  retryLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19.07px',
    textTransform: 'none',
  },
  errorMsg: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#000000',
    textAlign: 'center',
  },
}));

function RetryScreen() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(640);

  const handleRetryButtonClick = () => {
    dispatch(loadOrderHistoryPage());
  };

  return (
    <EVPaper square={isMobile} className={classes.retryScreenPaper}>
      <EVTypography className={classes.errorMsg}>{t('order_history__loading_error')}</EVTypography>
      <EVButton
        id="retryButton"
        variant="contained"
        color="primary"
        className={classes.retryBtn}
        classes={{ label: classes.retryLabel }}
        onClick={handleRetryButtonClick}
      >
        <EVRefreshOutlinedIcon />
        {t('order_history__retry')}
      </EVButton>
    </EVPaper>
  );
}

export default RetryScreen;
